/* eslint-disable react/react-in-jsx-scope */
import React from 'react'
import { useEffect, useState } from 'react';
import Head from 'next/head'
import style from './engagedUsersSurvey.module.css'
import consts from './consts'
import utils from './utils'
import CloseIcon from './closeIcon'
import CheckMark from './checkMark'
import { useStateValue } from '../state';

export default function EngagedUsersSurvey({onClose}) {
  const [showThankYou, updateShowThankYou] = useState(false);
  const [show, updateShow] = useState(false);
  const [showTypeForm, updateShowTypeForm] = useState(false);
  const offerFeatures = ['Up to 50GB per transfer', 'Extended 30 days file retention', 'Branded download page', 'Blazing fast upload & download speed'];

  //const [showGif, updateShowGif] = useState(false);

  const gifsAddresses = ['https://media.giphy.com/media/dBKA8QfHeRhzf3UmsN/giphy.gif'];

  const [
    {showEngagedSurveyModal},
  ] = useStateValue()

  useEffect(() => {
     let modalSeen = utils.getLocalStorageItem(consts.LOCAL_STORAGE_KEYS.ENGAGED_SURVEY_SHOWED);
     if(!modalSeen) {
        updateShow(true);
        utils.setLocalStorageItem(consts.LOCAL_STORAGE_KEYS.ENGAGED_SURVEY_SHOWED,true,100);
       /* let random = getRandomInt(2);
        if(random) {
          updateShowGif(true);
        }
        utils.trackPageView(`EngagedUsersSurvey${showGif ? 'gif' : 'image'}`);*/
        utils.trackPageView('EngagedUsersSurvey');
     }
    }, [])

    useEffect(() => {
      if(showThankYou) {
         let timeOut = setTimeout(() => {
           updateShowThankYou(false);
           onClose && onClose();
        }, 2000);
         return () => {
          clearTimeout(timeOut);
      }
      }
    }, [showThankYou])

  function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

    function renderIcon() {
      return (
        <img className={style.image} src={gifsAddresses[0]}/> 
      );
     /* return ( !showGif ?
        <img className={style.image} src={gifsAddresses[0]}/> :
        <svg className={style.icon} xmlns="http://www.w3.org/2000/svg" width="105" height="105" viewBox="0 0 105 105" fill="none">
        <path d="M99.0726 22.0161H89.7581V8.46774H91.4516C92.3873 8.46774 93.1452 7.70988 93.1452 6.77419V1.69355C93.1452 0.757863 92.3873 0 91.4516 0H64.3548C63.4192 0 62.6613 0.757863 62.6613 1.69355V6.77419C62.6613 7.70988 63.4192 8.46774 64.3548 8.46774H66.0484V22.0161H56.7339C53.4611 22.0204 50.8107 24.6708 50.8065 27.9436V57.5806H44.0323V49.9597C44.028 46.6869 41.3776 44.0365 38.1048 44.0323H26.25C22.9772 44.0365 20.3268 46.6869 20.3226 49.9597V57.5806H5.92742C2.65464 57.5849 0.00423387 60.2353 0 63.5081V99.0726C0.00423387 102.345 2.65464 104.996 5.92742 105H58.4274C61.7002 104.996 64.3506 102.345 64.3548 99.0726V98.2258H93.1452V103.306C93.1452 104.242 93.903 105 94.8387 105H99.9194C100.855 105 101.613 104.242 101.613 103.306V97.6521C103.679 96.6699 104.998 94.5868 105 92.2984V27.9436C104.996 24.6708 102.345 22.0204 99.0726 22.0161ZM10.1613 101.613H5.92742C4.52389 101.611 3.38921 100.476 3.3871 99.0726V63.5081C3.38921 62.1045 4.52389 60.9699 5.92742 60.9677H10.1613V101.613ZM16.9355 101.613H13.5484V60.9677H16.9355V101.613ZM23.7097 49.9597C23.7118 48.5562 24.8465 47.4215 26.25 47.4194H38.1048C39.5084 47.4215 40.643 48.5562 40.6452 49.9597V57.5806H23.7097V49.9597ZM44.0323 101.613H20.3226V60.9677H44.0323V101.613ZM50.8065 101.613H47.4194V60.9677H50.8065V101.613ZM66.0484 3.3871H89.7581V5.08065H66.0484V3.3871ZM86.371 8.46774V22.0161H69.4355V8.46774H86.371ZM60.9677 99.0726C60.9656 100.476 59.8309 101.611 58.4274 101.613H54.1936V60.9677H58.4274C59.8309 60.9699 60.9656 62.1045 60.9677 63.5081V99.0726ZM62.6613 59.3652V37.2581H66.0484V84.6774H64.3548V63.5081C64.3548 61.9585 63.7473 60.4703 62.6613 59.3652ZM98.2258 101.613H96.5323V98.2258H98.2258V101.613ZM101.613 92.2984C101.611 93.7019 100.476 94.8366 99.0726 94.8387H64.3548V88.0645H67.7419C68.6776 88.0645 69.4355 87.3067 69.4355 86.371V35.5645C69.4355 34.6288 68.6776 33.871 67.7419 33.871H60.9677C60.0321 33.871 59.2742 34.6288 59.2742 35.5645V57.642C58.9948 57.6018 58.7111 57.5806 58.4274 57.5806H54.1936V27.9436C54.1957 26.54 55.3303 25.4053 56.7339 25.4032H99.0726C100.476 25.4053 101.611 26.54 101.613 27.9436V92.2984Z" fill="#13BCB4"/>
        <path d="M81.2905 33.8711H74.5163C73.5806 33.8711 72.8228 34.629 72.8228 35.5646V86.3711C72.8228 87.3068 73.5806 88.0646 74.5163 88.0646H81.2905C82.2262 88.0646 82.984 87.3068 82.984 86.3711V35.5646C82.984 34.629 82.2262 33.8711 81.2905 33.8711ZM79.5969 84.6775H76.2099V37.2582H79.5969V84.6775Z" fill="#13BCB4"/>
        <path d="M94.8388 33.8711H88.0646C87.129 33.8711 86.3711 34.629 86.3711 35.5646V86.3711C86.3711 87.3068 87.129 88.0646 88.0646 88.0646H94.8388C95.7745 88.0646 96.5324 87.3068 96.5324 86.3711V35.5646C96.5324 34.629 95.7745 33.8711 94.8388 33.8711ZM93.1453 84.6775H89.7582V37.2582H93.1453V84.6775Z" fill="#13BCB4"/>
        </svg>
      );*/
    }

    function renderHeartIcon(){
      return (
      <svg className={style.heartIcon} xmlns="http://www.w3.org/2000/svg" width="155" height="138" viewBox="0 0 155 138" fill="none">
      <path d="M138.786 73.6905L77.568 134L16.3497 73.6905C12.3118 69.782 9.13123 65.0843 7.00822 59.893C4.88521 54.7018 3.86579 49.1295 4.01415 43.5271C4.16251 37.9247 5.47544 32.4135 7.87025 27.3407C10.2651 22.2678 13.6899 17.7431 17.9291 14.0515C22.1682 10.3599 27.1299 7.58135 32.5017 5.89087C37.8734 4.20038 43.5389 3.63456 49.1413 4.22903C54.7436 4.8235 60.1616 6.56538 65.054 9.34499C69.9464 12.1246 74.2071 15.8817 77.568 20.3798C80.9435 15.9144 85.2092 12.1901 90.0982 9.43997C94.9872 6.68986 100.394 4.97314 105.981 4.39725C111.568 3.82136 117.214 4.3987 122.566 6.09313C127.918 7.78756 132.861 10.5626 137.085 14.2446C141.309 17.9266 144.724 22.4362 147.115 27.4913C149.507 32.5464 150.824 38.0381 150.984 43.6227C151.143 49.2073 150.142 54.7646 148.044 59.9467C145.945 65.1289 142.793 69.8243 138.786 73.7392" stroke="#13BCB4" stroke-width="6.25" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      );
    }

    function renderThankYou() {
      return (
        <div className={style.thankYouContainer}>
          {renderHeartIcon()}
          <span className={style.thankYouTitle}>
            Thank You!
          </span>
        </div>
      )
    }

    function renderEmbeddedTypeForm() {
      return (
      <div className="typeform-widget" data-url="https://form.typeform.com/to/jCCxhrI1?typeform-medium=embed-snippet"
      data-transparency="50" data-hide-headers="false" data-hide-footer="false" style={{width: '100%', height: '562px', position: 'relative', top: '50px', display: !showTypeForm ? 'none' : 'block'}}/>
      );
    }

    function renderFeature(featureText) {
      return (
        <div className={style.planFeatureContainer}>
          <CheckMark/>
      <span className={style.planFeatureText}>{featureText}</span>
        </div>
      );
    }


    return (
      showEngagedSurveyModal && show && <React.Fragment>
        <Head>
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: `
          (function() { var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm", b="https://embed.typeform.com/"; if(!gi.call(d,id)) { js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q) } })()
          `}} />
        </Head>
    <div className={style.overlayContainer}>
  <div className={style.container}>
      <div className={style.modalContent}>
     { showThankYou ? renderThankYou() :
     <React.Fragment>
      <CloseIcon onClick={onClose} iconStyle={{
          width: "30px", 
          height: "30px",
          cursor: "pointer",
          position: 'absolute',
          top: '0px',
          right: '0px',
          marginTop: '16px',
          marginRight: '14px',
          zIndex: 10,
          opacity: 0.5,
       }} svgStyle={{position: 'relative', left: '0.5px', top: '0.5px'}}/>
       {renderEmbeddedTypeForm()}
       <div style={{display: showTypeForm ? 'none' : 'block'}}>
        {renderIcon()}
        <span className={style.header}>We’d Love to get<br/>your feedback!</span>
        <span className={style.answerText}>Hi there! 👋
            <br/> Help us improve the experience for you and the rest of our users by completing a 1-minute survey and get FileDrive Pro for Free!</span>
        <div className={style.offerContainer}>
          <div className={style.offerContent}>
            <span className={style.offerHeader}>Get FileDriver Pro for 2 months FREE!</span>
            {offerFeatures.map(feature => {
              return renderFeature(feature)
            })}
          </div>  
        </div>      
        <button onClick={() => updateShowTypeForm(true)} className={style.sendButton}>Start Survey</button>
        <span className={style.footer}>Thanks, you rock! <br/> The FileDriver team 💚</span>
        </div>
     </React.Fragment>}
      </div>
   </div>
      </div>
      </React.Fragment> 
    )
  }